export const DefaultMarkers =
  '[{"lat":61.14009563040699,"lng":-114.6018657894011},{"lat":59.40432513713809,"lng":-112.98252263795787},{"lat":57.841288754888545,"lng":-103.3518657894011}]'
export const DefaultCenter =
  '{"lat": 59.40432513713809, "lng": -112.98252263795787}'
export const DefaultZoom = 3
export const Libraries: "places"[] = ["places"]
export const LatitudeFieldName = "lat"
export const LongitudeFieldName = "lng"
export const ContainerStyle = {
  width: "100%",
  height: "100%",
}
